/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ names: NonNullable<unknown> }} My_Integrations_Wizard_Link_PartialInputs */



/**
* | output |
* | --- |
* | "The integration was added, but these projects could not be linked: {names}." |
*
* @param {My_Integrations_Wizard_Link_PartialInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const my_integrations_wizard_link_partial = /** @type {((inputs: My_Integrations_Wizard_Link_PartialInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Integrations_Wizard_Link_PartialInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Die Integration wurde hinzugefügt, aber diese Projekte konnten nicht verknüpft werden: ${i?.names}.`)
	return /** @type {LocalizedString} */ (`The integration was added, but these projects could not be linked: ${i?.names}.`)
});